import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonical?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogType?: 'website' | 'article';
  ogImage?: string;
  twitterHandle?: string;
}

const SEO: React.FC<SEOProps> = ({
  title,
  description,
  keywords,
  canonical,
  ogTitle,
  ogDescription,
  ogType = 'website',
  ogImage,
  twitterHandle = `@${(import.meta.env.VITE_COMPANY_NAME || 'Brand').toLowerCase().replace(/\s/g, '')}`,
}) => {
  const brandName = import.meta.env.VITE_COMPANY_NAME || 'Brand';
  const fullTitle = title ? `${title} | ${brandName}` : brandName;
  const defaultDescription = import.meta.env.VITE_COMPANY_SUBHEADLINE || `${brandName} | Instant Salary Advance Protocol`;
  const siteUrl = import.meta.env.VITE_WEBSITE_LINK || 'https://namanfinlease.com';

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      {canonical && <link rel="canonical" href={`${siteUrl}${canonical}`} />}

      {/* Open Graph Tags */}
      <meta property="og:title" content={ogTitle || fullTitle} />
      <meta property="og:description" content={ogDescription || description || defaultDescription} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={siteUrl + (canonical || '')} />
      {ogImage && <meta property="og:image" content={ogImage} />}
      <meta property="og:site_name" content={brandName} />

      {/* Twitter Card Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={ogTitle || fullTitle} />
      <meta name="twitter:description" content={ogDescription || description || defaultDescription} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}
      {twitterHandle && <meta name="twitter:site" content={twitterHandle} />}
      {twitterHandle && <meta name="twitter:creator" content={twitterHandle} />}
    </Helmet>
  );
};

export default SEO;
